<template>
  <div class="challenge-hero" :style="{'background-image': `url('${getImageForChallenge}')`}">
    <Container class="challenge-title">
      <div @click="goBackTo" class="cursor-pointer hover:underline">
        <Icon name="arrow-left" size="14"/>
        {{ $t('back_to', { item: backLabel }) }}
      </div>
      <h1>{{ challenge.title }}</h1>
    </Container>
  </div>
</template>

<script>
  import FollowButton from '../../components/FollowButton/FollowButton.vue'
  import BasicHero from '../BasicHero/BasicHero.vue'
  import TranslationsMixin from '../../util/TranslationsMixin'
  import { Carousel, Navigation, Slide } from 'vue3-carousel'
  import Container from '@/components/Container/Container.vue'
  import ActorDetailSDGs from '@/pages/ActorDetail/ActorDetailSDGs.vue'
  import { getDefaultFallbackImageUrl } from '@/util/helpers'

  export default {
    name: 'ChallengeHero',
    mixins: [TranslationsMixin],
    props: {
      challenge: {
        type: Object,
        required: true,
      },
      showSubTitle: {
        default: true,
        type: Boolean,
      },
      collapseHero: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      goBackTo () {
        if (this.$route.params.communityId) {
          if (this.$route.query.curation && this.$route.query.curation === 'challenge') {
            return this.$router.push(`/communities/${this.$route.params.communityId}/curation?curation=challenge`)
          }

          return this.$router.push(`/communities/${this.$route.params.communityId}/challenges`)
        }
        return this.$router.push('/challenges')
      },
    },
    computed: {
      backLabel () {
        if (this.$route.query.curation && this.$route.query.curation === 'challenge') {
          return this.$t('curation')
        }

        return this.challengesLabel
      },
      getImageForChallenge () {
        if (!this.challenge.imageURL || !this.challenge.imageURL.length) {
          return getDefaultFallbackImageUrl()
        }

        return this.challenge.imageURL
      },
    },
    components: {
      ActorDetailSDGs,
      Container,
      BasicHero,
      FollowButton,
      Carousel,
      Slide,
      Navigation,
    },
  }
</script>

<style lang="scss">
  .challenge-hero {
    position: relative; // Make sure this is set
    width: 100%;
    height: 300px;
    background-position: center;
    background-size: cover;
    background-origin: border-box;

    // Dark overlay
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.5); // Adjust opacity as needed
      z-index: 1;
    }

    .challenge-title {
      position: relative; // Bring title above the overlay
      z-index: 2;
      color: white;
      padding-top: 4rem;
    }

    .basic-hero {
      position: relative;
      z-index: 2; // Ensure all child content appears above the overlay
    }

    .basic-hero {
      padding-top: 2.5rem;
      padding-bottom: 0px;
      text-align: left;

      .basic-hero__slot {
        width: 100%;

        .basic-hero-nav-bar {
          background: transparent;
          justify-content: flex-start;

          .top-bar__links {
            display: flex;
            overflow: hidden;
            justify-content: flex-start;
            align-items: baseline;

            .button {
              padding: 10px 12px 10px;
            }

            :deep(.button__label) {
              color: white;
              text-transform: uppercase;
            }

            .button--minimal:focus {
              // override !important in focus-state.scss
              box-shadow: none !important;
            }


            .second-top-bar__link-active {
              background-color: rgba(204, 204, 204, 0.1);
              color: white;
            }
          }
        }
      }
    }
  }

</style>
